import { render, staticRenderFns } from "./BlogManager.vue?vue&type=template&id=0c5db5eb&lang=pug"
import script from "./BlogManager.vue?vue&type=script&lang=js"
export * from "./BlogManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports